import { useUserContext } from "@/context/user.context";
import { UserCapability } from "@/types/user";

export const useCanManageClientFit = () => {
  const { capabilities, initialized, isInternal } = useUserContext();

  return (
    initialized &&
    isInternal &&
    capabilities.includes(UserCapability.ManageClientFit)
  );
};
